import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_BASE_URL } from '../config/api.config';
import { SupervisionSessionService } from '../services/supervision-session.service';

// El backend entrega la sesión por cookies (access_token/refresh_token, ver POST
// /auth/login/otp). Como la API vive en otro origen que el frontend, hace falta pedir
// explícitamente que el navegador las envíe y las guarde en cada llamada al gateway.
export const withCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(API_BASE_URL)) {
    return next(req);
  }
  const exchangeUrl = `${API_BASE_URL}/admin/impersonations/exchange`;
  if (req.url === exchangeUrl || inject(SupervisionSessionService).isSupervising()) {
    // Una supervisión se autentica solo por Bearer; nunca mezcla cookies de otra sesión.
    return next(req.clone({ withCredentials: false }));
  }
  return next(req.clone({ withCredentials: true }));
};
